import React from 'react';
import useSWR from "swr";
import {swrFetcher} from "../../utils/api.ts";
import {Link} from "wouter";
import {useDocumentTitle} from "usehooks-ts";
import RenderPlatformIcon from "../../components/RenderPlatformIcon.tsx";
import Spinner from "@/components/spinner.tsx";

function MyAccounts() {
    useDocumentTitle("My Accounts")
    const {data, isLoading} = useSWR('/accounts', swrFetcher)
    return (
        <div>
            {
                document.location.hash === "#success" ? <p className={"alert alert-success"}>Connection Successful</p> : null
            }

            <div className="row">
                <div className="col-md-6">
                    <h2 className={"text-4xl mb-2"}>My Accounts</h2>
                    <p className="text-muted">Your connected social media accounts</p>
                </div>
                <div className="col-md-6">
                    {
                        data?.accounts.length > 0 ? <Link className={"btn btn-primary"} to={'/accounts_connect'}>Connect New Account</Link> : null
                    }
                </div>
            </div>
            <div className="my-4">
            {
                isLoading ? <Spinner /> : <>
                    {
                        data?.accounts.length === 0 ? <div><p>You have not connected any social media account. <Link to={"/accounts_connect"}>Connect one here</Link></p>
                                <div  className={"mt-3"}>
                                    <Link to={"/accounts_connect"} className={"btn btn-primary"}>Connect Account</Link>
                                </div>
                            </div>
                            : <div className={"max-w-lg"}>
                                <div className="rounded-xl border overflow-hidden border-base-200 divide-y divide-base-200">
                                {
                                    data.accounts.map((i)=>{
                                        return <Link to={`/accounts/details/${i.id}`} className={"flex hover:bg-base-200 items-center gap-2 p-3"} key={String(i.key)}>
                                            <RenderPlatformIcon platform={i.platform}/>
                                            <span>{i.username || i.name}</span>
                                        </Link>
                                    })
                                }
                            </div></div>
                    }
                </>
            }

            </div>
        </div>
    );
}

export default MyAccounts;
